import axios from 'axios';
import { API_CALL_ERROR, BRANCHES_ENDPOINT } from './_ConstantsAPI';

export async function getBranch(branchId) {
  try {
    const { data } = await axios.get(BRANCHES_ENDPOINT, {
      params: {
        branchId: branchId,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    return { isSuccessful: false, data: API_CALL_ERROR };
  }
}
